import React from 'react';
import { safeRenderData } from '../../utils/safeRender';
import { SafeRenderBoundary } from './SafeRenderBoundary';
import { useCommonTranslation } from '../../modules/i18n/hooks/useTranslation';

interface GenericErrorBannerProps {
  message: string;
  onClose?: () => void;
  className?: string;
}

const GenericErrorBanner: React.FC<GenericErrorBannerProps> = ({ message, onClose, className = '' }) => {
  const { t } = useCommonTranslation();
  return (
    <SafeRenderBoundary fallbackMessage={t('error.displayError')}>
      <div className={`rounded-md border border-red-200 bg-red-50 p-4 ${className}`}>
        <div className='flex items-start'>
          <div className='flex-shrink-0'>
            <svg className='h-5 w-5 text-red-400' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z'
              />
            </svg>
          </div>
          <div className='ml-3 flex-1'>
            <h3 className='text-sm font-medium text-red-800'>{t('status.error')}</h3>
            <p className='mt-1 text-sm text-red-700'>{safeRenderData(message)}</p>
          </div>
          {onClose && (
            <div className='ml-auto pl-3'>
              <div className='-mx-1.5 -my-1.5'>
                <button
                  onClick={onClose}
                  className='inline-flex rounded-md p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50'
                >
                  <span className='sr-only'>{t('actions.close')}</span>
                  <svg className='h-5 w-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
                  </svg>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </SafeRenderBoundary>
  );
};

export default GenericErrorBanner;
